// src/utils/hash.js
import Hashids from 'hashids';

const hashids = new Hashids('your-secret-salt', 10);

export const encodeId = (id) => hashids.encode(id);
export const decodeId = (hash) => hashids.decode(hash)[0];
